import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopSpecializationsByDemandGraduatesView = async (urlDataAPI: any) => {
    const { exportType, hubIds, locations, fromTimeline, toTimeline } = urlDataAPI;
    const { path, method } = endpoints.educationCareerPath.exportTopSpecializationsByDemandGraduatesView;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, hubIds, locations, fromQuarter: fromTimeline, toQuarter: toTimeline },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
